export default {"src":"/_next/static/media/firepit.319ce2f4.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};